import React from "react";
import { Document } from "../objects/Document.interface";
import { useState } from 'react';
import { DndContext, DragEndEvent, DragOverEvent } from "@dnd-kit/core";
import { arrayMove, SortableContext } from "@dnd-kit/sortable";
import DocumentItemList from "./DocumentItemList";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { arrayMoveImmutable } from "array-move";
import { DocumentService } from '../services/Documents.service';

export type DocumentListProps = {
    list: Document[],
    showDocument:(document:Document) => void,
}

export default function DocumentList(props:DocumentListProps){

    const [documentList, setDocuments] =  useState<Document[]>(props.list);
    
    if(props.list.length > 0 && (documentList.length == 0 || documentList.length != props.list.length))
    {
        setDocuments(props.list);   
    }


    const handleDragEnd =  (event: DragEndEvent) =>{
        const {active, over} = event;

        if(over && active.id !== over.id)
        {
            const documentService = new DocumentService();

            const oldIndex =  documentList.findIndex(item => item.id === active.id);
            const newIndex =  documentList.findIndex(item => item.id === over.id);
            
            var newSort = arrayMoveImmutable(documentList, oldIndex, newIndex);

            setDocuments(newSort);
  
            newSort.forEach((item, index) => {
                item.sort = index + 1;
            });

            documentService.updateBulk(newSort);
         
        }

        var documentToShot = documentList.find(item => item.id == active.id);
        if(documentToShot)
        {
            props.showDocument(documentToShot);
            
        }
    }
    const handleDragOver =  (event: DragOverEvent) =>{
        const {active, over} = event;

        if(over && active.id !== over.id)
        {


         
        }

        
    }
    return (
        
        <div className="area-document-list ">
            <DndContext
                modifiers={[restrictToVerticalAxis]}
                onDragEnd={handleDragEnd}
                onDragOver={handleDragOver}
            >
                <SortableContext items={documentList}>
                    {
                    
                        documentList.map((document,index) => (
                            <DocumentItemList key={document.id} doc={document} ></DocumentItemList>
                        ))
                    }
                </SortableContext>
            </DndContext>
        </div>
    )
}